import List from './StudentList'
import Registration from './StudentRegistration'
import Enroll from './EnrollStudentCourse'
import Profile from './StudentProfile'

const exportObj = {
    List,
    Registration,
    Enroll,
    Profile
}

export default exportObj